export default {"src":"/_next/static/media/icon-1.8d89b1af.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};